import(/* webpackMode: "eager" */ "/opt/JNLP/71d6017a/workspace/NonProd_frontend_release-preprod/app/error.tsx");
